import { useContext } from "react";
import { LoggedIn } from "../../LoggedIn";
import { LoggedOut } from "../../LoggedOut";
import { APP_VERSION, useStoredValue } from "../../util";
import styles from "./Main.module.css";
import backgroundDark from "./backgroundDark.svg";
import backgroundLight from "./backgroundLight.svg";
import { ThemeContext } from "../../themes/Theme";
import { ClientIdContext, featuresForClientId } from "../../ClientConfig";
import { useNavigate } from "react-router-dom";
import * as Token from "../../api/auth_token";
import * as client from "../../client";

export const Main = () => {
  const navigate = useNavigate();
  const { value: clientId, set: setClientId } = useStoredValue(
    Token.STORED_CLIENT_ID_KEY
  );
  const hasAuthToken = Token.useHasToken();
  const isAuthed = clientId && hasAuthToken;

  const { theme } = useContext(ThemeContext);
  const isLightMode = theme === "light";
  const imgSrc = isLightMode ? backgroundLight : backgroundDark;

  const onSuccessfulAuth = (
    clientId: string,
    user: client.User | undefined
  ) => {
    setClientId(clientId);
    const features = featuresForClientId(clientId, navigate);
    navigate(features?.defaultRoute(user));
  };

  return (
    <ClientIdContext.Provider value={clientId}>
      <div className={styles.app}>
        <img src={imgSrc} className={styles.backgroundImg} />
        {isAuthed ? (
          <LoggedIn />
        ) : (
          <LoggedOut onSuccessfulAuth={onSuccessfulAuth} />
        )}
        <span className={styles.versionText}>{"version " + APP_VERSION}</span>
      </div>
    </ClientIdContext.Provider>
  );
};
